/* eslint-disable @typescript-eslint/no-explicit-any */
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  CircularProgress,
  Typography,
} from '@mui/material';

import { useGetGlobalLetterTemplate } from '../hooks';

import { CreateLetterTemplate, EditLetterTemplates } from './letter-templates';

export const LetterTemplates = () => {
  const { data, isLoading, isError, refetch } = useGetGlobalLetterTemplate();
  const letterTemplates = Array.isArray(data) ? data : [];

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" p={2}>
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return (
      <Box p={2}>
        <Typography color="error">
          Error loading letter templates.
          <Box
            component="span"
            sx={{ cursor: 'pointer', textDecoration: 'underline' }}
            onClick={() => refetch()}
          >
            Try again
          </Box>
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>Edit Letter Templates</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <EditLetterTemplates data={letterTemplates} />
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>Create Letter Template</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <CreateLetterTemplate data={letterTemplates} />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
